var _rect, _rect2, _path, _rect3, _path2, _rect4, _rect5, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlots4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 141,
    viewBox: "0 0 209 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 209,
    height: 140.577,
    rx: 4,
    fill: "#004552"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 75,
    width: 75.5998,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.256 103.182C58.7987 103.182 58.3577 103.119 57.933 102.993C57.5083 102.862 57.1257 102.676 56.785 102.433C56.449 102.186 56.183 101.88 55.987 101.516C55.791 101.147 55.693 100.723 55.693 100.242H57.079C57.093 100.606 57.1957 100.916 57.387 101.173C57.5783 101.43 57.835 101.626 58.157 101.761C58.479 101.892 58.8453 101.957 59.256 101.957C59.872 101.957 60.3503 101.81 60.691 101.516C61.0363 101.222 61.209 100.853 61.209 100.41C61.209 100.125 61.1367 99.8757 60.992 99.661C60.852 99.4463 60.6303 99.2807 60.327 99.164C60.0283 99.0427 59.6387 98.982 59.158 98.982H58.073V97.932H58.899C59.515 97.932 60.0003 97.806 60.355 97.554C60.7097 97.2973 60.887 96.9497 60.887 96.511C60.887 96.119 60.74 95.79 60.446 95.524C60.152 95.258 59.725 95.125 59.165 95.125C58.7217 95.125 58.3273 95.216 57.982 95.398C57.6367 95.5753 57.408 95.895 57.296 96.357H55.917C55.987 95.7783 56.169 95.3093 56.463 94.95C56.757 94.5907 57.1327 94.3293 57.59 94.166C58.0473 94.0027 58.5583 93.921 59.123 93.921C59.7343 93.921 60.2803 94.026 60.761 94.236C61.2463 94.4413 61.6267 94.7283 61.902 95.097C62.1773 95.4657 62.315 95.8903 62.315 96.371C62.315 96.833 62.1843 97.232 61.923 97.568C61.6663 97.8993 61.2907 98.1537 60.796 98.331C61.3467 98.499 61.7947 98.7673 62.14 99.136C62.4853 99.5 62.658 99.962 62.658 100.522C62.658 101.04 62.518 101.5 62.238 101.901C61.958 102.302 61.5637 102.617 61.055 102.846C60.5463 103.07 59.9467 103.182 59.256 103.182Z",
    fill: "#004552"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 75,
    width: 75.5998,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.963 93.97H145.23V99.78H146.777V100.914H145.23V103H143.914V100.914H139.343V99.899L143.963 93.97ZM143.97 96L140.918 99.899H143.97V96Z",
    fill: "#004552"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 21,
    width: 75.5998,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 75.5998,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.239 49V47.593C140.239 47.0843 140.319 46.6573 140.477 46.312C140.636 45.962 140.867 45.6703 141.17 45.437C141.474 45.2037 141.842 45.003 142.276 44.835L144.068 44.135C144.498 43.9623 144.817 43.743 145.027 43.477C145.237 43.211 145.342 42.882 145.342 42.49C145.342 42.084 145.2 41.748 144.915 41.482C144.631 41.216 144.227 41.083 143.704 41.083C143.196 41.083 142.773 41.1997 142.437 41.433C142.106 41.6617 141.917 42.0047 141.87 42.462H140.393C140.417 41.9067 140.571 41.44 140.855 41.062C141.14 40.684 141.525 40.3993 142.01 40.208C142.496 40.0167 143.053 39.921 143.683 39.921C144.271 39.921 144.799 40.033 145.265 40.257C145.732 40.481 146.101 40.7913 146.371 41.188C146.647 41.5847 146.784 42.042 146.784 42.56C146.784 43.022 146.7 43.4257 146.532 43.771C146.364 44.1117 146.117 44.408 145.79 44.66C145.464 44.912 145.067 45.1313 144.6 45.318L142.78 46.039C142.37 46.1977 142.064 46.3843 141.863 46.599C141.667 46.809 141.569 47.0843 141.569 47.425V47.775H146.714V49H140.239Z",
    fill: "#004552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4804 40.047H60.5164V49H59.1864V41.622C58.9531 41.7573 58.7151 41.8623 58.4724 41.937C58.2298 42.007 57.9871 42.0467 57.7444 42.056V40.768C58.0478 40.7307 58.3418 40.656 58.6264 40.544C58.9158 40.4273 59.2004 40.2617 59.4804 40.047Z",
    fill: "#004552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots4);
export default __webpack_public_path__ + "static/media/slots-4.e84a63defa1d0ad52fa23ffc4353bca1.svg";
export { ForwardRef as ReactComponent };